export default __webpack_public_path__ + "a45108d3b34af91f9113d827a183296d.woff";